import { Column } from "./Column";

export const SkeletonUserInfo = () => {
	return (
		<div className="w-full sm:w-[30rem] h-full sm:max-h-[43rem] bg-white overflow-y-auto overflow-x-hidden sm:rounded-xl ">
            <div className="sm:hidden h-16" />
			<div className="bg-zinc-800 mb-4 sm:mb-5">
				<Column
					mainAxisAlignment="center"
					crossAxisAlignment="center"
					className="animate-pulse w-full h-[25rem] md:h-[30rem] relative md:rounded-xl md:rounded-b-none select-none bg-black"
				>
					<svg
						viewBox="0 0 16 20"
						fill="currentColor"
						aria-hidden="true"
						className="w-10 h-10 text-gray-300"
					>
						<path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"></path>
						<path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"></path>
					</svg>
				</Column>
			</div>
			<div className="animate-pulse px-3">
				<div className="flex gap-2">
					<div className="h-8 bg-gray-300 rounded-full w-24 mb-1" />
                    <div className="w-8 h-8 bg-gray-300 rounded-full"/>
                </div>
				<div className="h-4 bg-gray-300 rounded-full w-32 mb-1" />
				<div className="flex gap-1">
					<div className="h-4 bg-gray-300 w-4 rounded-full mb-1" />
					<div className="h-4 bg-gray-300 w-8 rounded-full mb-1" />
					<div className="h-4 bg-gray-300 w-16 rounded-full mb-1" />
					<div className="h-4 bg-gray-300 w-32 rounded-full mb-1" />
				</div>
				<div className="h-8 bg-gray-300 w-24 rounded-full mb-1" />
				<div className="w-full border-t-[0.5px] my-4 border-grayLight" />
				<div className="h-7 bg-gray-300 rounded-full w-20 mb-1" />
				<div className="h-3 bg-gray-300 rounded-full mb-1" />
				<div className="h-3 bg-gray-300 rounded-full mb-1" />
				<div className="h-3 bg-gray-300 rounded-full w-4/5 mb-1" />
				<div className="h-7 bg-gray-300 rounded-full w-20 mb-1 mt-4" />
				<div className="flex gap-1">
					<div className="h-4 bg-gray-300 w-10 rounded-full mb-1" />
					<div className="h-4 bg-gray-300 w-8 rounded-full mb-1" />
					<div className="h-4 bg-gray-300 w-14 rounded-full mb-1" />
					<div className="h-4 bg-gray-300 w-12 rounded-full mb-1" />
				</div>
				<div className="h-7 bg-gray-300 rounded-full w-20 mb-1 mt-4" />
				<div className="flex gap-1">
					<div className="h-6 bg-gray-300 w-16 rounded-full mb-1" />
					<div className="h-6 bg-gray-300 w-16 rounded-full mb-1" />
					<div className="h-6 bg-gray-300 w-16 rounded-full mb-1" />
					<div className="h-6 bg-gray-300 w-16 rounded-full mb-1" />
					<div className="h-6 bg-gray-300 w-16 rounded-full mb-1" />
				</div>
			</div>
		</div>
	);
};
